module.exports = __webpack_public_path__ + "static/drone-a446fb0007a1a755c724eec5a0c2e118.png";